import 'jquery.validate';
import $ from 'jquery';
import 'datatables';
import {beforeMainLoader, completeMainLoader, getFetch, getModelCallbacks} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';
import {responseParser} from '@sinclair-digital/stl-common/src/sinclair/sinclair.utils';
import {collections, search} from 'js/sinclair/sinclair.admin.utils';
import thumbTypeDropdownTemplate from '@sinclair-digital/stl-common/src/widgets/templates/thumbTypeDropdown.hbs';
import userAssignPropertyTemplate from 'templates/admin/userAssignPropertyTemplate.hbs';
import adminTemplate from 'templates/admin/adminTemplate.hbs';
import contextRoleFilterTemplate from 'templates/admin/contextRoleFilterTemplate.hbs';
import propertySearchResultTemplate from 'templates/admin/propertySearchResultTemplate.hbs';
import userRightPanelShellTemplate from 'templates/admin/userRightPanelShell.hbs';
import userFormTemplate from 'templates/admin/userFormTemplate.hbs';
import {messageHandler} from '@sinclair-digital/stl-common/src/sinclair/sinclair.uiTools';
import Backbone from 'backbone';
import ConfirmModal from 'components/ConfirmModal';
import React from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import Handlebars from 'handlebars';
import UserCollection from 'collections/admin/userCollection';
import UserModel from 'models/admin/userModel';
import RoleCollection from 'collections/admin/roleCollection';
import PropertyCollection from 'collections/admin/propertyCollection';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';

const AdminView = Backbone.View.extend({
    navId: 'admin-user-tab',
    sdaPageTitle: 'user administration',
    user: null,
    el: '#admin-main',
    dtEl: '#sda-main-search-result',

    events: {
        'click #sda-add-user-btn': 'showUserEditPanelHandler',

        'click #sda-save-user-btn': 'saveUser',
        'click #sda-close-user-form-btn': 'closeUserRightPanel',

        'click .user-delete': 'deleteUser',

        'change #userUuid': 'checkAll',

        'click #sda-main-search-result td.sda-row-user': 'showUserEditPanelHandler',

        'keydown #sda-main-search': '_keyDownUserSearchHandler',
        'click #sda-main-search-btn': 'userSearchHandler',
        'click .sda-context-role-filter': 'contextRoleFilterHandler',

        'keydown #sda-user-search': '_keyDownUserSearchHandler',
        'click #sda-advanced-search-clear': '_clearSearchHandler',
        'click #sda-advanced-search-close': 'toggleAdvancedSearch',
        'click .advanced-search': 'toggleAdvancedSearch',
        'click .sda-search-btn': '_addSearchFiltersHandler',
        'click .search-field-selector': '_searchSelectorHandler',
        'click .sda-add-filters-btn': '_addSearchFiltersHandler',
        'click .sda-remove-search-operator': '_removeSearchOperatorHandler',

        'keydown #sda-property-search': 'keyDownPropertySearchHandler',
        'click #sda-property-search-btn': 'propertySearchHandler',
        'click .sda-property-search-item': 'addAssignPropertyPanelHandler',
        'click .sda-assign-property-delete': 'deleteAssignPropertyPanelHandler',
        'click .sda-assign-property-context-role': 'toggleAssignPropertyContextRoleHandler',
        'sdaToggleChange .sda-jsTrigger-mfaEnabled': 'onMfaEnabledToggle',
        'sdaToggleChange .sda-jsTrigger-userEnabled': 'onUserEnabledToggle',
    },

    initialize() {
        bindAllMethods(this);
        this._setHandlebarsHelpers();
        Handlebars.registerPartial('userAssignPropertyTemplate', userAssignPropertyTemplate);
        this.render();
    },
    render() {
        this.userCollection = new UserCollection();
        this.roleCollection = new RoleCollection();

        if (this.permissionDenied('user-admin.create', 'global')) {
            return false;
        }

        this.$el.html(adminTemplate());

        this.dtUsers = $(this.dtEl)
            .DataTable({
                searching: false,
                lengthChange: false,
                bInfo: false,
                bPaginate: false,
                scrollY: '500px',
                scrollCollapse: true,
                width: '100%',
                data: [],
                columns: [
                    {
                        title: '<input type="checkbox" id="userUuid" value="all">',
                        data: 'uuid',
                        width: 30,
                        class: 'sda-row-user center',
                        render(data, type, row) {
                            return `<div data-user-uuid="${row.uuid}">
                                <input
                                    class="sda-row-user-checkbox"
                                    type="checkbox"
                                    name="sda-user-selector"
                                    value="${row.uuid}" />
                            </div>`;
                        },
                    },
                    {
                        title: 'name',
                        data: 'username',
                        class: 'sda-row-user sda-row-user-name',
                        render(data, type, row) {
                            return (
                                '<span class="sda-row-user-fullname">' +
                                (row.firstName ? row.firstName : '') +
                                ' ' +
                                (row.lastName ? row.lastName : '') +
                                '</span>' +
                                '<span class="sda-row-user-username">' +
                                (row.username ? row.username : '') +
                                '</span>'
                            );
                        },
                    },
                    {
                        title: 'property',
                        data: 'properties',
                        class: 'sda-row-user center',
                        render(data, type, row) {
                            let properties = '';
                            if (row.properties && $.isArray(row.properties)) {
                                $.each(row.properties, function(i, propertyWrapper) {
                                    if (i > 0) {
                                        properties += ', ';
                                    }
                                    if (propertyWrapper.roles && propertyWrapper.roles.length > 0) {
                                        if (propertyWrapper.property) {
                                            properties += propertyWrapper.property.name;
                                        } else {
                                            properties += 'ALL SINCLAIR PROPERTIES';
                                        }
                                    }
                                });
                            }
                            return properties;
                        },
                    },
                    {
                        title: 'groups',
                        data: 'ldapGroups',
                        class: 'sda-row-user center',
                        render(data, type, row) {
                            let ldapGroups = '';
                            if (row.ldapGroups && $.isArray(row.ldapGroups)) {
                                $.each(row.ldapGroups, function(i, ldapGroup) {
                                    if (i > 0) {
                                        ldapGroups += ', ';
                                    }
                                    ldapGroups += ldapGroup;
                                });
                            }
                            return ldapGroups;
                        },
                    },
                    {
                        title: 'Actions',
                        data: 'uuid',
                        width: 50,
                        class: 'center',
                        render(data, type, row) {
                            let actionButtons = '';
                            if (!row.distinguishedName) {
                                actionButtons =
                                    '<a href="#admin" class="user-delete" data-user-uuid="' + row.uuid + '">Delete</a>';
                            }
                            return actionButtons;
                        },
                    },
                ],
                createdRow(row, data) {
                    if (data.distinguishedName) {
                        $('td', row).addClass('ldap_user');
                    }

                    if ($('#userUuid').prop('checked')) {
                        $('.sda-row-user-checkbox', row).prop('checked', true);
                    }
                },
            })
            .on('column-sizing.dt', () => {
                this.tableResizeFix();
            });

        if (this.userCollection.length === 0) {
            beforeMainLoader();

            this.loadedPages = {0: true};

            collections({
                that: this,
                userUrl: '/api/user',
                userCollection: this.userCollection,
                roleCollection: this.roleCollection,
            })
                .done(() => {
                    $('.dataTables_scrollBody').bind('scroll', this.scrollPagingHandler);
                    completeMainLoader();
                })
                .fail(() => {
                    messageHandler('error', 'You have not enough permissions.');
                    completeMainLoader();
                });
        }

        search.defaults({
            that: this,
        });

        this._setUpSearchSelectorDropdown();

        return this;
    },

    /**************** USER SEARCH ******************/

    _keyDownUserSearchHandler(e) {
        const $caller = $(e.currentTarget);
        const event = e.originalEvent;
        const enter = 13;

        if (event.which === enter) {
            event.preventDefault();
            $caller.blur();
            if ($caller.attr('id') === 'sda-main-search') {
                this.doUserSearch(0, true);
                $caller.focus();
            } else if ($caller.attr('id') === 'sda-user-search') {
                this._addSearchFiltersHandler();
                $caller.focus();
            }
        }
    },

    renderSearchResult(opts) {
        function isModelShown(shownModels, model) {
            let isShown = false;
            for (let i = 0; i < shownModels.length; i++) {
                if (shownModels[i].uuid === model.get('uuid')) {
                    isShown = true;
                    break;
                }
            }
            return isShown;
        }

        const shownModels = opts.that.dtUsers.rows().data();
        const data = opts.userCollection.filter(user => !isModelShown(shownModels, user)).map(user => user.toJSON());
        opts.that.dtUsers.rows.add(data).draw(false);

        opts.that.offset = opts.pagingParams ? opts.pagingParams.offset || 0 : 0;
    },

    renderUserRoleFilter(opts) {
        const roles = opts.roleCollection.models.map(model => model.attributes);
        $('#sda-context-role-filters').html(contextRoleFilterTemplate(roles));
        $('.sda-context-role-filter')
            .first()
            .addClass('active');
    },

    scrollPagingHandler(e) {
        const $target = $(e.target);

        if ($target.scrollTop() + $target.innerHeight() >= $target[0].scrollHeight) {
            const pageIndex = Math.floor(this.userCollection.models.length / search.searchObj.limit);
            console.log('scroll paging: loading page: ' + pageIndex);
            this.doUserSearch(pageIndex, false);
        } else {
            console.log('not end reached');
        }
    },

    userSearchHandler() {
        this.doUserSearch(0, true);
    },

    doUserSearch(pageIndex, isNewSearch) {
        if (isNewSearch) {
            this.loadedPages = {};
        } else if (this.loadedPages[pageIndex]) {
            return;
        }
        this.loadedPages[pageIndex] = true;

        const roleIds = $('.sda-context-role-filter.active').attr('data-role-ids');

        if (isNewSearch) {
            this.dtUsers.clear();
            this.userCollection.reset();
        }

        beforeMainLoader();

        collections({
            that: this,
            $queryContainer: $('.sda-search-query-container'),
            $searchInput: $('#sda-main-search'),
            userCollection: this.userCollection,
            userUrl: '/api/user',
            roleIds,
            pageIndex,
        })
            .done(completeMainLoader)
            .fail(() => {
                messageHandler('error', 'You have not enough permissions.');
                completeMainLoader();
            });
    },

    contextRoleFilterHandler(e) {
        $('.sda-context-role-filter').removeClass('active');
        $(e.currentTarget).addClass('active');

        $('#sda-main-search').val('');

        this.doUserSearch(0, true);
    },

    /**************** ADVANCED SEARCH ******************/

    toggleAdvancedSearch() {
        $('.sda-search-nav').toggleClass('nav-search-open');
    },
    _clearSearchHandler() {
        search.clearSearch();
    },

    _setUpSearchSelectorDropdown() {
        const operatorOpts = {
            list: [
                {
                    name: 'contains',
                    value: 'LIKE',
                    classes: 'non-date tag',
                    //icon: 'fa-square'
                },
                {
                    name: 'is',
                    value: 'EQUALS',
                    classes: 'date non-date tag',
                    //icon: 'fa-th-large'
                },
                {
                    name: 'is not',
                    value: 'NOTEQUALS',
                    classes: 'non-date',
                    //icon: 'fa-th'
                },
            ],
            template: thumbTypeDropdownTemplate,
        };
        const fieldOpts = {
            list: [
                {
                    name: 'any field',
                    value: 'all',
                    classes: 'test',
                    //icon: 'fa-square'
                },
                {
                    name: 'username',
                    value: 'username',
                    classes: 'test',
                    //icon: 'fa-th'
                },
                {
                    name: 'first name',
                    value: 'firstName',
                    classes: 'test',
                    //icon: ''
                },
                {
                    name: 'last name',
                    value: 'lastName',
                    classes: 'test',
                    //icon: 'fa-bars'
                },
                {
                    name: 'email',
                    value: 'email',
                    classes: 'test',
                    //icon: 'fa-bars'
                },
                {
                    name: 'groups',
                    value: 'userProfileFieldValues.userProfileField.name',
                    classes: 'test',
                    //icon: 'fa-bars'
                },
            ],
            template: thumbTypeDropdownTemplate,
        };

        operatorOpts.selected = operatorOpts.list[0];
        fieldOpts.selected = fieldOpts.list[0];

        if (!$('#search-fields .sda-select-selected').length) {
            $('#search-fields').sdaSelect(fieldOpts);
            $('#search-fields')
                .find('.sda-select-selected')
                .attr('data-value', fieldOpts.selected.value)
                .attr('data-name', fieldOpts.selected.name);
        }
        if (!$('#search-operators .sda-select-selected').length) {
            $('#search-operators').sdaSelect(operatorOpts);
            $('#search-operators')
                .find('.sda-select-selected')
                .attr('data-value', operatorOpts.selected.value)
                .attr('data-name', operatorOpts.selected.name);
        }

        const that = this;
        $('#search-fields').on('select', function(e, value) {
            const $selected = $(this)
                .data()
                .getSelectedEl();
            $(this)
                .find('.sda-select-selected')
                .attr({
                    'data-value': value,
                    'data-name': $selected.data().name,
                });
            $('#search-operators').set('LIKE');

            that._searchSelectorHandler(e, value);
        });
        $('#search-operators').on('select', function(e, value) {
            const $selected = $(this)
                .data()
                .getSelectedEl();
            $(this)
                .find('.sda-select-selected')
                .attr({
                    'data-value': value,
                    'data-name': $selected.data().name,
                });

            that._searchSelectorHandler(e, value);
        });
    },

    _addSearchFiltersHandler() {
        search.addSearchFiltersHandler({
            that: this,
            filterField: $('#search-fields .sda-select-selected'),
            operator: $('#search-operators .sda-select-selected'),
            queryContainer: $('.sda-search-query-container'),
            searchInput: $('#sda-user-search'),
        });
    },
    _removeSearchOperatorHandler(e) {
        search.removeSearchOperatorHandler(e, {
            that: this,
            $filterButton: $('.sda-add-filters-btn'),
            $searchButton: $('.sda-search-btn'),
            $queryContainer: $('.sda-search-query-container>div'),
            $searchInput: $('#sda-user-search'),
        });
        return false;
    },
    _searchSelectorHandler(e) {
        search.searchSelectorHandler(e, {
            that: this,
            $filterButton: $('.sda-add-filters-btn'),
            $searchButton: $('.sda-search-btn'),
            $searchInput: $('#sda-user-search'),
            $filterField: $('#search-fields'),
            $operator: $('#search-operators'),
        });
        return false;
    },

    /**************** PROPERTY SEARCH ******************/

    keyDownPropertySearchHandler(e) {
        const $caller = $(e.currentTarget);
        const event = e.originalEvent;
        const enter = 13;
        if (event.which === enter) {
            event.preventDefault();
            $caller.blur();
            if ($caller.attr('id') === 'sda-property-search') {
                this.propertySearchHandler();
                $caller.focus();
            }
        }
    },

    propertySearchHandler() {
        const opts = {
            that: this,
            $searchResultContainer: $('.sda-property-search-container'),
            $searchIcon: $('#sda-property-search-btn i'),
            propertyCollection: new PropertyCollection(),
        };

        opts.propertyCollection.reset();

        const $searchInput = $('#sda-property-search');
        const searchValue = $searchInput ? $searchInput.val() : null;
        if (searchValue && searchValue.length > 0) {
            opts.$searchIcon.removeClass('fa-search').addClass('fa-refresh fa-spin');

            const propertyUrl = opts.propertyCollection.url + '/search-by-name?siteName=' + searchValue;
            opts.propertyCollection.getProperties(propertyUrl, opts.propertyCollection, function() {
                opts.that.renderPropertySearchResult(opts);

                opts.$searchIcon.removeClass('fa-refresh fa-spin').addClass('fa-search');
            });
        }
    },

    renderPropertySearchResult(opts) {
        const properties = [];
        $.each(opts.propertyCollection.models, function(i, model) {
            properties.push(model.attributes);
        });
        if (properties.length > 0) {
            opts.$searchResultContainer.html(propertySearchResultTemplate(properties)).show();
        } else {
            opts.$searchResultContainer.hide();
        }
    },

    addAssignPropertyPanelHandler(e) {
        let $target = $(e.target);
        $target = $target.hasClass('sda-property-search-item') ? $target : $target.closest('.sda-property-search-item');
        if ($target.is('[data-uuid]')) {
            const propertyUuid = $target.attr('data-uuid');
            const $propertyEl = $('.sda-assign-property[data-uuid=' + propertyUuid + ']');

            if ($propertyEl.length === 0) {
                const roles = [];
                $.each(this.roleCollection.models, (i, roleInfo) => {
                    if (roleInfo.getRoles()) {
                        roles.push({
                            id: roleInfo.getContextRoleId(),
                            name: roleInfo.getName(),
                        });
                    }
                });

                const property = {
                    uuid: propertyUuid,
                    name: $target.attr('data-name'),
                    type: $target.attr('data-type'),
                };
                this.model.addProperty(property);

                const renderPropertyData = {
                    property,
                    roles,
                };
                $('#sda-assign-property-container').append(userAssignPropertyTemplate(renderPropertyData));
            }
        }

        $('#sda-property-search').val('');
        $('.sda-property-search-container').hide();
    },

    deleteAssignPropertyPanelHandler(e) {
        const $target = $(e.target);

        const $assignProperty = $target.closest('.sda-assign-property');
        const propertyUuid = $assignProperty.attr('data-uuid');
        this.model.removeProperty(propertyUuid);
        $assignProperty.remove();
    },

    toggleAssignPropertyContextRoleHandler(e) {
        const $contextRole = $(e.target);
        const roleId = parseInt($contextRole.attr('data-id'), 10);

        const $property = $contextRole.closest('.sda-assign-property');
        const propertyUuid = $property.attr('data-uuid');

        if ($contextRole.hasClass('active')) {
            this.model.unassignPropertyContextRole(propertyUuid, roleId);
        } else {
            this.model.assignPropertyContextRole(propertyUuid, roleId);
        }
        $contextRole.toggleClass('active');
    },
    //  USER ADD/EDIT
    showUserEditPanelHandler(e) {
        const that = this;
        const $target = $(e.target);
        let options;
        let model = this.model;
        const opts = {
            before() {
                that.openUserRightPanel();
                $('#sda-user-panel').html(userRightPanelShellTemplate(options));
                $('#sda-user-panel-loader').show();
            },
            success() {
                that.setEditPanel(model);
            },
            error() {},
        };

        const $row = $target
            .closest('tr')
            .find('td:first-child')
            .find('div');
        if ($row.is('[data-user-uuid]')) {
            $('.sda-row-user-checkbox').prop('checked', false);
            $row.find('.sda-row-user-checkbox').prop('checked', true);
            $('#userUuid').prop('checked', false);

            const uuid = parseInt($row.attr('data-user-uuid'), 10);
            model = this.userCollection.where({uuid})[0];
            options = {
                action: 'Edit',
                user: {
                    uuid,
                    firstName: model.get('firstName'),
                    lastName: model.get('lastName'),
                },
            };

            model.url = opts.url = '/api/user/' + uuid;
            model.fetch(getFetch(opts));
        } else {
            options = {
                action: 'Add New',
                user: {
                    uuid: null,
                    properties: [],
                },
            };

            this.openUserRightPanel();
            $('#sda-user-panel').html(userRightPanelShellTemplate(options));
            $('#sda-user-panel-loader').show();

            this.setEditPanel(new UserModel(options.user));
        }
    },

    setEditPanel(model) {
        this.model = model;
        const renderUserData = this.model.toJSON();

        if (renderUserData.properties.every(({property}) => property != null)) {
            renderUserData.properties.push({
                property: null,
                roles: [],
            });
            this.model.addProperty();
        }

        renderUserData.properties.forEach(propertyWrapper => {
            const propertyRoles = propertyWrapper.roles;
            const newRoles = [];
            const isGlobalProperty = propertyWrapper.property == null;
            this.roleCollection.models.forEach(roleInfo => {
                if (roleInfo.getRoles()) {
                    let propertyRole =
                        this.findObjectByKey(propertyRoles, 'id', roleInfo.getGlobalRoleId()) ||
                        this.findObjectByKey(propertyRoles, 'id', roleInfo.getContextRoleId());
                    if (propertyRole) {
                        propertyRole.status = 'active';
                        propertyRole.name = propertyRole.name || roleInfo.getName();
                    } else {
                        propertyRole = {};
                        if (isGlobalProperty) {
                            propertyRole.id = roleInfo.getGlobalRoleId();
                        } else {
                            propertyRole.id = roleInfo.getContextRoleId();
                        }
                        propertyRole.name = roleInfo.getName();
                    }
                    newRoles.push(propertyRole);
                }
            });
            propertyWrapper.roles = newRoles;
        });

        $('#sda-user-main-panel')
            .html(
                userFormTemplate(
                    Object.assign({}, renderUserData, {isMfaEnabled: this.userModel.debugModel.getFeatureFlag('mfaFeatureFlag')}),
                ),
            )
            .fadeIn(100, this._attachValidator);

        $('#sda-user-panel-loader').hide();
    },

    onMfaEnabledToggle({target}) {
        this.model.set({mfaRequired: target.value});
    },

    onUserEnabledToggle({target}) {
        this.model.set({enabled: target.value});
    },

    openUserRightPanel() {
        const $panel = $('#sda-user-panel');
        if (!$panel.hasClass('panel-open')) {
            $panel.addClass('panel-open');
        }
        this.tableResizeFix();
    },

    closeUserRightPanel() {
        const $panel = $('#sda-user-panel');
        if (!$panel.hasClass('panel-closed')) {
            $panel.removeClass('panel-open');
            $('#sda-user-panel').empty();
            this.uncheckAll();
        }
    },

    tableResizeFix() {
        // DataTables fix: set width to 100% for change width dynamically then slice user right panel
        $('#sda-main-search-result_wrapper')
            .find('.dataTables_scrollHeadInner')
            .css('width', '100%')
            .children('table')
            .css('width', '100%');

        $('#sda-main-search-result').css('width', '100%');
    },

    saveUser(e) {
        const that = this,
            options = {
                success(model, response, data, opts) {
                    if (response.success !== false) {
                        that._saveUserSuccessHandler(model, response, data, opts);
                    } else if ((response.message ?? '').match(/^Error response:/gi)) {
                        const message = JSON.parse((response.message ?? '')
                            .replace(/^Error response:/gi, '')
                            .replace(/^\s+|\s+$/g, ''));

                        that._saveUserFailureHandler(
                            model,
                            {
                                status: 412,
                                responseText: JSON.stringify({
                                    ...response,
                                    ...message,
                                }),
                            },
                            opts
                        );
                    } else if (response.message) {
                        const isEmail = response.message.toLowerCase().includes('email');
                        const isUserName = response.message.toLowerCase().includes('username');
                        const isName = response.message.toLowerCase().includes('name');

                        let name = '';
                        if (isEmail) {
                            name = 'email';
                        } else if (isUserName) {
                            name = 'username';
                        } else if (isName) {
                            name = 'firstname';
                        }

                        if (name) {
                            that._saveUserFailureHandler(
                                model,
                                {
                                    status: 412,
                                    responseText: JSON.stringify({
                                        success: false,
                                        ...response,
                                        data: [
                                            {
                                                name,
                                                msg: response.message,
                                            },
                                        ],
                                    }),
                                },
                                opts
                            );
                        } else {
                            console.error(response.message);
                            messageHandler('error', response.message);
                        }
                    }
                },
                failure(data, response, opts) {
                    that._saveUserFailureHandler(data, response, opts);
                },
                error(model, response, opts) {
                    that._saveUserFailureHandler(model, response, opts);
                },
                before() {
                    beforeMainLoader();
                    $('#sda-save-user-btn').addClass('disabled');
                },
                complete() {
                    $('#sda-save-user-btn').removeClass('disabled');
                    completeMainLoader();
                },
            },
            $userForm = $('#sda-user-form');

        if ($userForm.valid()) {
            const fields = $userForm.serializeArray();
            const attrs = {};
            $.each(fields, function(i, field) {
                attrs[field.name] = field.value;
            });

            const checkboxes = $userForm.find('input[type="checkbox"]');
            $.each(checkboxes, function(i, field) {
                attrs[field.name] = field.checked;
            });

            this._clearErrorList();
            this.model.set(attrs);
            this.model.save({}, getModelCallbacks(options));
        }

        e.preventDefault();
    },
    _saveUserSuccessHandler(model, response, data) {
        const raw = responseParser(data.xhr.responseText);
        const $msg = $('#sda-settings-msg');

        if (typeof raw === 'object' && data.xhr.success) {
            if (model.changed.uuid) {
                model.url = '/api/user/' + model.changed.uuid;

                const options = {
                    action: 'Edit',
                    user: model.attributes,
                };
                $('#sda-user-panel').html(userRightPanelShellTemplate(options));
                this.setEditPanel(model);
                this.doUserSearch(0, true);
            } else {
                let isUserShown = false;
                this.userCollection.models.forEach(mdl => {
                    isUserShown = isUserShown || model.get('uuid') === mdl.get('uuid');
                });
                if (isUserShown) {
                    this.userCollection.add(model, {merge: true});

                    const rows = this.userCollection.models.map(user => user.toJSON());
                    this.dtUsers.clear();
                    this.dtUsers.rows.add(rows).draw(false);
                }
                this.closeUserRightPanel();
            }

            $msg.removeClass('alert-danger').addClass('alert-success');
            $msg.html('Your changes have been successfully saved.');
            $msg.slideDown(function() {
                setTimeout(function() {
                    $msg.slideUp(function() {
                        $msg.removeClass('alert-success').addClass('alert-danger');
                    });
                }, 3000);
            });
        }
    },

    _saveUserFailureHandler(model, response) {
        const raw = responseParser(response.responseText);

        if (typeof raw === 'object' && !raw.success) {
            if (raw && raw.data[0]) {
                const errorList = [];
                if (response.status === 412) {
                    $.each(raw.data, function(i, data) {
                        errorList.push({
                            element: {id: 'sda-user-' + data.name},
                            message: data.msg,
                        });
                    });
                }
                if (errorList.length) {
                    this._setErrorList({errorList});
                } else {
                    this._clearErrorList();
                }
            }
        }
    },

    deleteUser(e) {
        e.preventDefault();
        const uuid = parseInt(e.target.dataset.userUuid, 10);
        if (!uuid) {
            return;
        }
        const model = this.userCollection.where({uuid})[0];
        const container = this.el.querySelector('#confirm-target');
        const modal = (
            <ConfirmModal
                onCancel={unmountComponentAtNode.bind(null, container)}
                onConfirm={this.onDeleteConfirm.bind(this, uuid)}>
                You are about to delete {model.get('firstName')} {model.get('lastName')}.<br />
                This action cannot be undone.
            </ConfirmModal>
        );
        render(modal, container);
    },
    onDeleteConfirm(uuid) {
        const container = this.el.querySelector('#confirm-target');
        unmountComponentAtNode(container);
        const options = {
            success: this.deleteUserSuccessHandler,
            failure: this._deleteUserFailureHandler,
            error: this._deleteUserFailureHandler,
            before: beforeMainLoader,
            complete: completeMainLoader,
        };

        const _model = new UserModel({uuid});
        _model.url = '/api/user/' + uuid;
        _model.destroy(getModelCallbacks.call(this, options));
    },

    checkAll() {
        $('.sda-row-user-checkbox').prop('checked', $('#userUuid').prop('checked'));
    },
    uncheckAll() {
        $('.sda-row-user-checkbox').prop('checked', false);
    },

    deleteUserSuccessHandler(model, response, data) {
        const raw = responseParser(data.xhr.responseText);
        const $msg = $('#sda-settings-msg');

        if (typeof raw === 'object' && raw.success) {
            this.userCollection.remove(model);

            const rows = this.userCollection.models.map(user => user.toJSON());
            this.dtUsers.clear();
            this.dtUsers.rows.add(rows).draw(false);

            $msg.removeClass('alert-danger').addClass('alert-success');
            $msg.html('User has been deleted.');
            $msg.slideDown(function() {
                setTimeout(function() {
                    $msg.slideUp(function() {
                        $msg.removeClass('alert-success').addClass('alert-danger');
                    });
                }, 3000);
            });
        }
    },

    _deleteUserFailureHandler(data, response) {
        const raw = responseParser(response.responseText),
            $msg = $('#sda-settings-msg');

        $msg.html(raw.data[0].msg);
        $msg.slideDown(function() {
            setTimeout(function() {
                $msg.slideUp();
            }, 3000);
        });
    },

    _attachValidator() {
        const that = this,
            $form = $('#sda-user-form');

        $form.validate(that.validator());
    },

    validator() {
        $.validator.addMethod(
            'nospace',
            function(value) {
                return !value.includes(' ') && value !== '';
            },
            'Your field must not have spaces',
        );

        const rules = {
            username: {
                required: true,
                minlength: 4,
                maxlength: 32,
                nospace: true,
            },
            firstName: {
                required: true,
                minlength: 1,
                maxlength: 32,
            },
            lastName: {
                required: true,
                minlength: 1,
                maxlength: 32,
            },
            email: {
                required: true,
                email: true,
            },
        };

        if (this.model.get('uuid') == null || this.model.get('uuid').length === 0) {
            rules.password = {
                required: true,
                minlength: 6,
            };
            rules.passwordConfirm = {
                required: true,
                minlength: 6,
                equalTo: '#sda-user-password',
            };
        }

        const that = this;
        return {
            invalidHandler(event, validator) {
                // 'this' refers to the form
                const errors = validator.numberOfInvalids();
                if (errors) {
                    that._setErrorList(validator);
                } else {
                    that._clearErrorList();
                }
            },
            showErrors() {},
            errorPlacement() {},
            rules,
            messages: {
                username: {
                    required: 'Please provide a User Name',
                    minlength: 'Your User Name must consist of at least 4 characters',
                    maxlength: 'Your User Name must consist of no more than 32 characters',
                    nospace: 'Your User Name must not have spaces',
                },
                firstName: {
                    required: 'Please provide a First Name',
                    minlength: 'Your First Name must consist of at least 1 characters',
                    maxlength: 'Your First Name must consist no more than 32 characters',
                },
                lastName: {
                    required: 'Please provide a Last Name',
                    minlength: 'Your Last Name must consist of at least 1 characters',
                    maxlength: 'Your Last Name must consist no more than 32 characters',
                },
                email: {
                    required: 'Please provide a Email',
                    email: 'Please enter a valid Email address.',
                },
                password: {
                    required: 'Please provide a password',
                    minlength: 'Your password must be at least 6 characters long',
                },
                passwordConfirm: {
                    required: 'Please provide a password',
                    minlength: 'Your password must be at least 6 characters long',
                    equalTo: 'Please enter the same password as above',
                },
            },
            tooltip_options: {
                // eslint-disable-line camelcase
                firstName: {
                    trigger: 'focus',
                },
                lastName: {
                    placement: 'right',
                },
            },
            highlight() {},
            unhighlight() {},
            submitHandler() {
                that._submitSitesSettingsForm();
            },
        };
    },

    _setErrorList(validator) {
        const $errorList = $(validator.errorList);

        this._clearErrorList();
        $errorList.each(function() {
            $('#' + this.element.id + '-error')
                .css('display', 'block')
                .html(this.message + '<div class="errors_triangle"></div>');
        });
    },

    _clearErrorList() {
        $('label.errors').css('display', 'none');
    },

    _setHandlebarsHelpers() {
        const hand = Handlebars || window.Handlebars;
        hand.registerHelper('if_eq', function(a, b, opts) {
            if (a === b) {
                return opts.fn(this);
            } else {
                return opts.inverse(this);
            }
        });
    },

    findObjectByKey(array, key, value) {
        if (array instanceof Array) {
            for (let i = 0; i < array.length; i++) {
                if (array[i][key] === value) {
                    return array[i];
                }
            }
        }
        return null;
    },

    clone(obj) {
        let copy;

        if (null == obj || 'object' !== typeof obj) return obj;

        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        if (obj instanceof Array) {
            copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.clone(obj[i]);
            }
            return copy;
        }

        if (obj instanceof Object) {
            copy = {};
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
            }
            return copy;
        }

        throw new Error('Unable to copy obj! Its type isn\'t supported.');
    },
});

export default AdminView;
